import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { SEO_CONFIG, DEFAULT_SEO } from '../config/seoConfig';

const matchDynamicRoute = (currentPath, routePattern) => {
  if (!routePattern.includes(':')) {
    return currentPath === routePattern;
  }

  const regexPattern = routePattern
    .replace(/:[^/]+/g, '([^/]+)')
    .replace(/\//g, '\\/');
  
  const regex = new RegExp(`^${regexPattern}$`);
  return regex.test(currentPath);
};

const ensureSiteNameInTitle = (title, siteName = 'BoleumLearn - Transform your career with expert-led online training') => {
  if (!title) return siteName;
  if (title.includes('BoleumLearn')) return title;
  return `${title} - BoleumLearn`;
};

const useRouteSEO = (dynamicOverrides = {}) => {
  const location = useLocation();
  const currentPath = location.pathname;

  const seoData = useMemo(() => {
    if (SEO_CONFIG[currentPath]) {
      return { ...SEO_CONFIG[currentPath] };
    }

    for (const [routePattern, config] of Object.entries(SEO_CONFIG)) {
      if (matchDynamicRoute(currentPath, routePattern)) {
        return { 
          ...config,
          title: dynamicOverrides.title 
            ? ensureSiteNameInTitle(dynamicOverrides.title) 
            : config.title,
          description: dynamicOverrides.description || config.description,
          image: dynamicOverrides.image || config.image,
          keywords: dynamicOverrides.keywords || config.keywords,
          robots: dynamicOverrides.robots || config.robots
        };
      }
    }

    return { ...DEFAULT_SEO };
  }, [currentPath, dynamicOverrides]);

  const canonicalUrl = `https://boleum.com/${currentPath}`;

  return {
    ...seoData,
    canonical: canonicalUrl,
    path: currentPath
  };
};

export default useRouteSEO;